<div class="modal fade" id="kt_modal_invoice_charge_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Invoice Charge' : 'Add Invoice Charge' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="invoiceChargeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="label"
                placeholder="Enter invoice charge name"
                [class.is-invalid]="label?.invalid && label?.touched"
              />
              <div *ngIf="label?.invalid && label?.touched" class="invalid-feedback">
                <div *ngIf="label?.errors?.['required']">Name is required</div>
                <div *ngIf="label?.errors?.['minlength']">Name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Value in USD -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Value in USD</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="usd"
                placeholder="Enter value in USD"
                min="0"
                step="0.01"
                [class.is-invalid]="usd?.invalid && usd?.touched"
              />
              <div *ngIf="usd?.invalid && usd?.touched" class="invalid-feedback">
                <div *ngIf="usd?.errors?.['required']">Value in USD is required</div>
                <div *ngIf="usd?.errors?.['min']">Value must be 0 or greater</div>
              </div>
            </div>

            <!-- Value in JPY -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Value in JPY</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="jpy"
                placeholder="Enter value in JPY"
                min="0"
                step="0.01"
                [class.is-invalid]="jpy?.invalid && jpy?.touched"
              />
              <div *ngIf="jpy?.invalid && jpy?.touched" class="invalid-feedback">
                <div *ngIf="jpy?.errors?.['required']">Value in JPY is required</div>
                <div *ngIf="jpy?.errors?.['min']">Value must be 0 or greater</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
